import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { rem } from 'polished';
import ModalRoute from '../common/components/ModalRoute';

import * as campaignActions from '../campaign/campaign.actions';
import * as contentActions from '../content/content.actions';
import * as prizeActions from '../prize/prize.actions';
import { getCurrentUser } from '../user/user.selectors';
import { getCurrentCampaign } from '../campaign/campaign.selectors';
import { getRulesForCurrentUser } from '../content/content.selectors';
import { getMainPrize, getSecondaryPrizes } from '../prize/prize.selectors';
import { UserRoles } from '../user/user.constants';
import { MainPrizeItem, PrizePreview, SecondaryPrizeItemList } from '../prize/components';
import { ContentBlock, ContentSection, PageHeader } from './components';
import { BestTeamsBlock, BestSellersBlock } from '../team/components';
import { BestRegionsBlock } from '../region/components';
import { LatestTransactionsBlock, SalesFormBlock, MyTransactionsBlock } from '../transaction/components';

import { ScoreVisualizerBlock } from '../user/components';
import { Localize } from '../../locale/localization';
import { Article } from '../content/components';
import PrizeTeamBonus from '../prize/components/PrizeTeamBonus';
import colorThemes from '../../ui/colorThemes';
import { formatDate } from '../../utils/date-utils';
import { API_ROOT } from '../../api/constants';


const HowToClaim = styled.footer`
  color: white;
  box-sizing: border-box;
  margin: 3rem auto 2rem auto;
  padding: 0 2rem;
  text-align: center;
  max-width: ${rem('600px')};

  h5 {
    font-family: FyranSans-SemiBold;
    font-size: 22px;
    margin-bottom: 1rem;
  }
  p {
    margin-bottom: 1rem;
    line-height: 1.2em;
    font-weight: 400;
    font-size: 18px;
  }
`;

const channelsWithTopRegions = [
  '59edc4c4289954cd790631dc', // DNA Aspa
  '59c36958de5cbece187dc79b', // MTV Testi
];

class PrizesPage extends Component {
  state = { count: 0, regions: [] };

  componentWillMount = () => {
    const { getPrizes, getCurrentCampaign, getContents } = this.props;
    getPrizes();
    getCurrentCampaign();
    getContents();

    if (this.hasTopRegions()) {
      if (this.isTeamleader()) {
        this.getTeamLeaderCount();
      }
      this.getTopRegions();
    }
  };

  onPrizeClick = id => {
    const { history } = this.props;
    history.push(`/prizes/preview/${id}`);
  };

  hasTopRegions = () => {
    const { currentUser } = this.props;
    return !currentUser.channel || channelsWithTopRegions.includes(currentUser.channel._id);
  };

  isTeamleader = () => {
    const { currentUser } = this.props;
    return currentUser.role === UserRoles.TEAMLEADER;
  };

  isTeamLeaderWithTopRegions = () => {
    return this.hasTopRegions() && this.isTeamleader();
  };

  getTeamLeaderCount = () => {
    const token = localStorage.getItem('cmore-sisapiiri-token');
    const url = `${API_ROOT}api/transaction/count/team`;
    const init = {
      method: 'GET',
      headers: new Headers({
        authtoken: `${token}`,
      }),
    };

    const that = this;

    fetch(url, init)
      .then(function(resp) {
        return resp.json();
      })
      .then(function(json) {
        that.setState(
          Object.assign({}, that.state, {
            count: json.count,
          })
        );
      });
  };

  getTopRegions = () => {
    const token = localStorage.getItem('cmore-sisapiiri-token');
    const url = `${API_ROOT}api/channel/top/regions`;
    const init = {
      method: 'GET',
      headers: new Headers({
        authtoken: `${token}`,
      }),
    };

    const that = this;

    fetch(url, init)
      .then(function(resp) {
        return resp.json();
      })
      .then(function(json) {
        that.setState(
          Object.assign({}, that.state, {
            regions: json,
          })
        );
      });
  };

  render() {
    const { currentUser, currentCampaign, mainPrize, secondaryPrizes, prizePreview, rules } = this.props;

    const campaignStarted = new Date(currentCampaign.startDate) <= new Date();
    const campaignEnded = new Date(currentCampaign.endDate) <= new Date();
    const campaignIsActive = campaignStarted && !campaignEnded;
    const currentYear = new Date().getFullYear();
    const cyrrentSeason = new Date() < new Date(currentYear,6,1) ? "Kevät "+currentYear.toString() : "Syksy "+currentYear.toString()
    const pageSubTitle =
      currentCampaign &&
      !campaignEnded &&
      (campaignIsActive ? `${cyrrentSeason} (voimassa ${formatDate(currentCampaign.endDate)} asti)` : `${cyrrentSeason}`); // (alkaa ${formatDate(currentCampaign.startDate)})`);
    const shouldRenderAdminContent =
      currentUser.role === UserRoles.SALESMANAGER ||
      currentUser.role === UserRoles.REGIONMANAGER ||
      currentUser.role === UserRoles.TEAMLEADER;
    const shouldRenderTransactionForm =
      (currentUser.role === UserRoles.SELLER || currentUser.role === UserRoles.TEAMLEADER) && campaignIsActive;
    const shouldRenderTeamBonus =
      (currentCampaign.bonusPercentage ||
        (currentCampaign.previousCampaign && currentCampaign.previousCampaign.bonusPercentage)) &&
      (currentUser.role === UserRoles.TEAMLEADER || currentUser.role === UserRoles.REGIONMANAGER);
    const shouldRenderTopTeamSellers = currentUser.role === UserRoles.SELLER;

    return (
      <div>
        <PageHeader title={Localize('prizes.header')} subTitle={pageSubTitle} />
        {(shouldRenderTeamBonus || this.isTeamLeaderWithTopRegions()) && (
          <ContentSection tight>
            <ContentBlock>
              <PrizeTeamBonus
                score={currentUser.bonusScore}
                showScore={!!shouldRenderTeamBonus}
                showTotal={this.isTeamLeaderWithTopRegions()}
                count={this.state.count}
              />
            </ContentBlock>
          </ContentSection>
        )}

        {(shouldRenderAdminContent || shouldRenderTransactionForm) && (
          <ContentSection tight>
            {shouldRenderAdminContent && (
              <ContentBlock title={Localize('team.top')} theme={colorThemes.DARK}>
                <BestTeamsBlock />
              </ContentBlock>
            )}
            {this.hasTopRegions() && (
              <ContentBlock title={Localize('region.top')} theme={colorThemes.DARK}>
                <BestRegionsBlock scores={this.state.regions} />
              </ContentBlock>
            )}
            {shouldRenderAdminContent && (
              <ContentBlock title={Localize('sellers.top')} theme={colorThemes.DARK}>
                <BestSellersBlock />
              </ContentBlock>
            )}
            {shouldRenderAdminContent && <LatestTransactionsBlock title={Localize('latest.sales')} />}
            {shouldRenderTransactionForm && (
              <ContentBlock half tight>
                <SalesFormBlock />
              </ContentBlock>
            )}
            {shouldRenderTransactionForm && <ScoreVisualizerBlock />}
          </ContentSection>
        )}

        {shouldRenderTopTeamSellers && (
          <ContentSection>
            <ContentBlock title={Localize('team.top.sellers')} theme={colorThemes.DARK}>
              <BestSellersBlock />
            </ContentBlock>
          </ContentSection>
        )}

        <ContentSection tight>
          <HowToClaim>
            <h5>Mikä ihmeen Palkinto-ohjelma?</h5>
            <p>
              Tässä esimerkkejä siitä mitä kaikkea voit pisteilläsi lunastaa. Jokainen myyty tuote kerryttää pisteitä.
              Tarvitset SuperLahjakortin lunastaaksesi palkintokaupasta lahjakortin/lahjan. SuperLahjakortti toimitetaan
              sinulle palkinto-ohjelman päätyttyä.
            </p>
            {rules && <NavLink to="/prizes/rules">Tarkemmat ohjeet ja säännöt</NavLink>}
          </HowToClaim>
          {mainPrize && <MainPrizeItem {...mainPrize} onClick={this.onPrizeClick} />}
          <SecondaryPrizeItemList items={secondaryPrizes} onItemClick={this.onPrizeClick} />
        </ContentSection>
        {prizePreview && (
          <ModalRoute exact path="/prizes/preview/:id" parentPath="/prizes">
            <PrizePreview prize={prizePreview} />
          </ModalRoute>
        )}
        {rules && (
          <ModalRoute exact path="/prizes/rules" parentPath="/prizes">
            <Article title={rules.name} content={rules.content} />
          </ModalRoute>
        )}

        {shouldRenderTransactionForm && (
          <ContentSection>
            <MyTransactionsBlock title={Localize('my.sales')} />
          </ContentSection>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, { match }) => {
  const currentUser = getCurrentUser(state);
  const currentCampaign = getCurrentCampaign(state);
  const mainPrize = getMainPrize(state);
  const secondaryPrizes = getSecondaryPrizes(state);
  const { id } = match.params;
  const prizePreview = id ? state.entities.prize.byId[id] : null;

  const rulesContent = getRulesForCurrentUser(state);
  const rules = rulesContent.length > 0 ? rulesContent[0] : null;

  return {
    currentUser,
    currentCampaign,
    mainPrize,
    secondaryPrizes,
    prizePreview,
    rules,
  };
};

const ConnectedPrizesPage = connect(
  mapStateToProps,
  Object.assign({}, campaignActions, prizeActions, contentActions)
)(PrizesPage);

export default withRouter(ConnectedPrizesPage);



// WEBPACK FOOTER //
// ./src/modules/pages/PrizesPage.js